export default __webpack_public_path__ + "static/media/12-32-24 2.45dc802f.jpg";